var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1432,
    height: 377,
    viewBox: "0 0 1432 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.901 258.553C156.604 259.257 156.999 260.211 156.999 261.205L156.999 373.251C156.999 375.322 158.678 377.001 160.749 377.001L193.249 377.001C195.32 377.001 196.999 375.322 196.999 373.251L196.999 261.483C196.999 260.488 197.394 259.535 198.097 258.831L198.83 258.098C199.534 257.395 200.487 257 201.482 257L232.796 257C233.79 257 234.744 257.395 235.448 258.098L235.902 258.553C236.605 259.256 237 260.21 237 261.204L237 293.25C237 295.321 238.679 297 240.75 297L273.25 297C275.321 297 277 295.321 277 293.25L277 260.75C277 258.679 275.321 257 273.25 257L241.206 257C240.211 257 239.257 256.605 238.554 255.902L238.098 255.446C237.395 254.743 237 253.789 237 252.794L237 220.75C237 218.679 235.321 217 233.25 217L201.206 217C200.211 217 199.257 216.605 198.554 215.902L198.098 215.446C197.395 214.743 197 213.789 197 212.794L197 180.75C197 178.679 195.321 177 193.25 177L160.75 177C158.679 177 157 178.679 157 180.75L157 213.072C157 214.067 156.605 215.021 155.902 215.724L155.723 215.903C155.02 216.606 154.066 217.001 153.071 217.001L120.749 217.001C118.678 217.001 116.999 218.68 116.999 220.751L116.999 253.073C116.999 254.068 116.604 255.022 115.901 255.725L115.724 255.902C115.02 256.605 114.067 257 113.072 257L80.75 257C78.6789 257 77 258.679 77 260.75L77 293.25C77 295.321 78.6789 297 80.75 297L113.25 297C115.321 297 117 295.321 117 293.25L117 261.482C117 260.488 117.395 259.534 118.098 258.831L118.83 258.099C119.533 257.396 120.487 257.001 121.481 257.001L152.795 257.001C153.79 257.001 154.743 257.396 155.447 258.099L155.901 258.553ZM158.553 255.903C159.257 256.606 160.21 257.001 161.205 257.001L193.071 257.001C194.066 257.001 195.02 256.606 195.723 255.903L195.902 255.724C196.605 255.021 197 254.067 197 253.072L197 221.204C197 220.21 196.605 219.256 195.902 218.553L195.448 218.098C194.744 217.395 193.79 217 192.796 217L161.482 217C160.487 217 159.534 217.395 158.83 218.098L158.097 218.831C157.394 219.535 156.999 220.488 156.999 221.483L156.999 252.795C156.999 253.79 157.394 254.744 158.097 255.447L158.553 255.903Z",
    fill: "url(#paint0_linear_1_78)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1243.5 106L1325.61 106C1326.51 106 1327.37 105.642 1328.01 105.006C1328.64 104.369 1329 103.506 1329 102.605L1329 80.5C1329 78.0147 1331.01 76 1333.5 76H1354.5C1356.99 76 1359 78.0148 1359 80.5V101.5C1359 103.985 1356.99 106 1354.5 106H1332.4C1331.49 106 1330.63 106.358 1329.99 106.995C1329.36 107.631 1329 108.495 1329 109.395V131.5C1329 133.985 1326.99 136 1324.5 136H1243.5C1241.01 136 1239 133.985 1239 131.5L1239 110.5C1239 108.015 1241.01 106 1243.5 106Z",
    fill: "url(#paint1_linear_1_78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.5 46C1271.01 46 1269 48.0147 1269 50.5L1269 71.5C1269 73.9853 1271.01 76 1273.5 76L1324.5 76C1326.99 76 1329 73.9853 1329 71.5V49.3954C1329 48.4949 1329.36 47.6313 1329.99 46.9945C1330.63 46.3578 1331.49 46 1332.4 46H1354.5C1356.99 46 1359 43.9853 1359 41.5V20.5C1359 18.0148 1356.99 16 1354.5 16L1333.5 16C1331.01 16 1329 18.0148 1329 20.5V42.6054C1329 43.5057 1328.64 44.3692 1328.01 45.0058C1327.37 45.6424 1326.51 46 1325.61 46L1273.5 46Z",
    fill: "url(#paint2_linear_1_78)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.37 283.715C1097.19 284.538 1098.31 285 1099.47 285H1130.61C1133.03 285 1135 286.966 1135 289.391V320.61C1135 323.035 1133.03 325.001 1130.61 325.001L1099.05 325.001C1097.98 325.001 1096.95 325.428 1096.19 326.188C1095.43 326.948 1095 327.979 1095 329.054V360.611C1095 363.035 1093.04 365.001 1090.61 365.001H1059.39C1056.97 365.001 1055 363.035 1055 360.611V329.472C1055 328.308 1054.54 327.191 1053.72 326.368L1053.63 326.287C1052.81 325.463 1051.69 325.001 1050.53 325.001H1019.39C1016.97 325.001 1015 323.035 1015 320.61V289.391C1015 286.966 1016.97 285 1019.39 285H1050.25C1051.42 285 1052.53 284.538 1053.36 283.714L1053.72 283.357C1054.54 282.533 1055 281.417 1055 280.252V249.39C1055 246.966 1056.97 245 1059.39 245H1090.61C1093.04 245 1095 246.966 1095 249.39V280.53C1095 281.695 1095.46 282.811 1096.29 283.635L1096.37 283.715ZM1093.64 286.286C1092.81 285.463 1091.7 285 1090.53 285H1059.05C1057.98 285 1056.95 285.427 1056.19 286.188C1055.43 286.948 1055 287.979 1055 289.054V320.531C1055 321.695 1055.46 322.812 1056.29 323.635L1056.37 323.715C1057.19 324.538 1058.31 325.001 1059.47 325.001L1090.25 325.001C1091.42 325.001 1092.54 324.538 1093.36 323.715L1093.71 323.36C1094.54 322.536 1095 321.42 1095 320.255V289.469C1095 288.304 1094.54 287.188 1093.71 286.364L1093.64 286.286Z",
    fill: "url(#paint3_linear_1_78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M945.187 38.8132C944.427 38.053 944 37.0219 944 35.9468L944 4.39019C944 1.96555 942.034 -2.05814e-06 939.609 -1.95216e-06L908.39 -5.87527e-07C905.966 -4.81543e-07 904 1.96556 904 4.3902L904 35.6093C904 38.034 905.966 39.9995 908.39 39.9995L939.251 39.9995C940.416 39.9995 941.532 40.4621 942.356 41.2854L942.714 41.6433C943.537 42.4666 944 43.5833 944 44.7476L944 75.6098C944 78.0344 945.965 80 948.39 80L979.609 80C982.034 80 983.999 78.0344 983.999 75.6098L983.999 44.3907C983.999 41.966 982.034 40.0005 979.609 40.0005L948.053 40.0005C946.978 40.0005 945.947 39.5734 945.187 38.8132Z",
    fill: "url(#paint4_linear_1_78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.1868 147.187C41.947 146.427 42.9781 146 44.0532 146H75.6098C78.0344 146 80 144.034 80 141.609V110.39C80 107.966 78.0344 106 75.6098 106H44.3907C41.966 106 40.0005 107.966 40.0005 110.39V141.251C40.0005 142.416 39.5379 143.532 38.7146 144.356L38.3567 144.714C37.5334 145.537 36.4167 146 35.2523 146H4.39019C1.96556 146 0 147.965 0 150.39V181.609C0 184.034 1.96556 185.999 4.39019 185.999H35.6093C38.034 185.999 39.9995 184.034 39.9995 181.609V150.053C39.9995 148.978 40.4266 147.947 41.1868 147.187Z",
    fill: "url(#paint5_linear_1_78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M381 205C384.314 205 387 207.686 387 211V239C387 242.314 384.314 245 381 245H353C349.686 245 347 242.314 347 239L347 211C347 207.686 349.686 205 353 205L381 205Z",
    fill: "url(#paint6_linear_1_78)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1393.19 187.187C1393.95 186.427 1394.98 186 1396.05 186H1427.61C1430.03 186 1432 184.034 1432 181.609V150.39C1432 147.966 1430.03 146 1427.61 146H1396.39C1393.97 146 1392 147.966 1392 150.39V181.251C1392 182.416 1391.54 183.532 1390.71 184.356L1390.36 184.714C1389.53 185.537 1388.42 186 1387.25 186H1356.39C1353.97 186 1352 187.965 1352 190.39V221.609C1352 224.034 1353.97 225.999 1356.39 225.999H1387.61C1390.03 225.999 1392 224.034 1392 221.609V190.053C1392 188.978 1392.43 187.947 1393.19 187.187Z",
    fill: "url(#paint7_linear_1_78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M538 6C541.314 6 544 8.68629 544 12V40C544 43.3137 541.314 46 538 46H510C506.686 46 504 43.3137 504 40L504 12C504 8.68629 506.686 6 510 6L538 6Z",
    fill: "url(#paint8_linear_1_78)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_78",
    x1: 177,
    y1: 377.001,
    x2: 177,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_78",
    x1: 1299,
    y1: 16,
    x2: 1299,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_78",
    x1: 1299,
    y1: 16,
    x2: 1299,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_78",
    x1: 1075,
    y1: 245,
    x2: 1075,
    y2: 365.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_78",
    x1: 904,
    y1: 40,
    x2: 983.999,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_78",
    x1: 40,
    y1: 106,
    x2: 40,
    y2: 185.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_78",
    x1: 367,
    y1: 205,
    x2: 367,
    y2: 245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_78",
    x1: 1392,
    y1: 146,
    x2: 1392,
    y2: 225.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_78",
    x1: 524,
    y1: 6,
    x2: 524,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/CTA.0b8dd7e9509ee3cff0568026b5b6f11f.svg";
export { ForwardRef as ReactComponent };